'use client';

import { useLayoutEffect } from "react";

export default function NotFound() {
  useLayoutEffect(() => {
    location.href = '/';
  }, []);

  return null;
}
